export const CTX_SERVER = 'sendRequestImpl'
export const CTX_AI_GROUPING_RESULT = 'aiGroupingResult'
export const VIRTUAL_TAG = 'virtual'
export const CONTAINER_GROUP = 'containerGroup'
export const CTX_SECTION_DATA = 'sectionInputData'
